import { Component, OnInit, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppointmentService } from '../../../services/appointment.service';
import { LanguageService } from '../../../services/language.service';

@Component({
  selector: 'app-floating-appointment',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './floating-appointment.html',
  styleUrl: './floating-appointment.scss'
})
export class FloatingAppointmentComponent implements OnInit {
  isVisible = false;
  isExiting = false;
  private exitTimeout: any;

  constructor(
    private appointmentService: AppointmentService,
    private languageService: LanguageService
  ) {}

  ngOnInit(): void {
    // Component initialization
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const shouldBeVisible = window.pageYOffset > 300;
    
    if (shouldBeVisible && !this.isVisible && !this.isExiting) {
      // Button is becoming visible
      this.isVisible = true;
      this.isExiting = false;
    } else if (!shouldBeVisible && this.isVisible && !this.isExiting) {
      // Button is becoming hidden - start exit animation
      this.isExiting = true;
      this.exitTimeout = setTimeout(() => {
        this.isVisible = false;
        this.isExiting = false;
      }, 400); // Match animation duration
    }
  }

  onAppointmentClick(): void {
    this.appointmentService.openAppointmentModal();
  }

  ngOnDestroy(): void {
    if (this.exitTimeout) {
      clearTimeout(this.exitTimeout);
    }
  }

  t(key: string): string {
    return this.languageService.t(key);
  }
}
